import { render, staticRenderFns } from "./increase.vue?vue&type=template&id=bb825b5c&"
import script from "@/model/increase?vue&type=script&lang=js&"
export * from "@/model/increase?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports